﻿// Init misc overriden/extended functionality

import es6_promise from 'es6-promise';
es6_promise.polyfill();                         // Require polyfill for es6 promises

import $ from 'jquery';                         // Twitter Bootstrap needs jQuery at global object. Don't use that!
window['jQuery'] = window['$'] = $;

window.require('bootstrap');                    // Attaches itself as a number of jQuery pluginsvar _ = require('underscore');

import * as _ from 'underscore';
window['_'] = _;                                // Compiled underscore templates need this for calling _.escape(...)

import * as Backbone from 'backbone';
import * as Backbone_localStorage from 'backbone.localStorage';
import * as Backbone_Syphon from 'backbone.syphon'; // Attaches itself to Backbone
import * as Backbone_Picky from 'backbone.picky';

import * as Marionette from 'backbone.marionette';
import * as Radio from 'backbone.radio';        // Attaches itself to Backbone and returns Radio at the same time for use in shim below

// Shim that make Marionette 2.x use Backbone.Radio instead of Backbone.Wreqr (though Mariontte will import Wreqr)
(Marionette.Application).prototype._initChannel = function () {
    this.channelName = _.result(this, 'channelName') || 'global';
    this.channel = _.result(this, 'channel') || Radio.channel(this.channelName);
}



require('../plugins/template');

